<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Height</span>
      <div class="wf-w-1/2">
        <select v-model="heightSelection" class="wf-w-full">
          <option value="FULL_SCREEN">full screen</option>
          <option value="SIX_HUNDRED_PIXELS">600px</option>
          <option value="FOUR_HUNDRED_PIXELS">400px</option>
          <option value="CUSTOM">custom</option>
        </select>
      </div>
    </li>
    <li v-show="heightSelection == 'CUSTOM'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center">
      <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide">custom value</span>
      <input
        v-model="height"
        type="text"
        class="wf-w-1/2 focus:wf-bg-gray-300 wf-text-sm wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
      />
    </li>
  </div>
</template>

<script>
  import { HeightStyle } from '../styles/HeightStyles'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    data() {
      return {
        heightSelection: 'FULL_SCREEN'
      }
    },
    watch: {
      heightSelection(value) {
        if(value == 'FULL_SCREEN') {
          return this.height = '100vh'
        }
        if(value == 'SIX_HUNDRED_PIXELS') {
          return this.height = '600px'
        }
        if(value == 'FOUR_HUNDRED_PIXELS') {
          return this.height = '400px'
        }
      }
    },
    computed: {
      height: {
        get() {
          let height = this.elementStyles(this.styles)[this.device].find(deviceStyle => deviceStyle.property == HeightStyle.property)
          if (! height) {
            height = {...HeightStyle, value: '400px', touched: false}
            this.heightSelection =  'FOUR_HUNDRED_PIXELS'
            this.addToArray(this.module, [height], this.styles, this.device, {}, true, this.parentModule)
          }
          return height.value
        },
        set(value) {
          let height = {...HeightStyle, value: value, touched: false}
          this.addToArray(this.module, [height], this.styles, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>
